"use strict";
import { el, round, esc, srTable } from "../util";
export function renderUnit(host, data) {
  host.innerHTML = "";
  host.classList.add("uc-wrap");
  const cols = data.cols || 11;
  const S = 30;
  const CELL = 38;
  const X0 = 2;
  const Y0 = 2;
  const segments = data.segments || [];
  const total = data.total || segments.reduce((s, x) => s + (x.count || 0), 0);
  if (data.title) host.insertAdjacentHTML("beforeend", `<h2 class="uc-head">${esc(data.title)}</h2>`);
  if (data.subtitle) host.insertAdjacentHTML("beforeend", `<p class="uc-sub">${esc(data.subtitle)}</p>`);
  const seq = [];
  segments.forEach((seg) => {
    for (let k = 0; k < seg.count; k++) seq.push(seg);
  });
  const rowsN = Math.ceil(seq.length / cols);
  const gridH = Y0 + rowsN * CELL;
  const W = X0 + cols * CELL;
  const legRows = Math.ceil(segments.length / 2);
  const legTop = gridH + 18;
  const ROWH = 44;
  const H = legTop + legRows * ROWH;
  const svg = el("svg", { viewBox: `0 0 ${W} ${H}`, width: "100%", class: "uc-svg", role: "img" });
  svg.setAttribute(
    "aria-label",
    `${data.title}. ${total} respondents: ` + segments.map((s) => `${s.label} ${s.count}`).join(", ")
  );
  seq.forEach((seg, i) => {
    const r = Math.floor(i / cols);
    const c = i % cols;
    svg.appendChild(el("rect", { x: X0 + c * CELL, y: Y0 + r * CELL, width: S, height: S, rx: 4, fill: seg.color }));
  });
  const colsX = [4, Math.round(W / 2) + 6];
  segments.forEach((seg, j) => {
    const ex = colsX[j % 2];
    const ey = legTop + Math.floor(j / 2) * ROWH;
    svg.appendChild(el("rect", { x: ex, y: ey, width: 16, height: 16, rx: 3, fill: seg.color }));
    const t1 = el("text", { x: ex + 24, y: ey + 8, class: "uc-lab", "dominant-baseline": "middle" });
    t1.textContent = seg.label;
    svg.appendChild(t1);
    const t2 = el("text", { x: ex + 24, y: ey + 25, class: "uc-sublab", "dominant-baseline": "middle" });
    t2.textContent = `${seg.count} ${seg.count === 1 ? "person" : "people"}`;
    svg.appendChild(t2);
  });
  host.appendChild(svg);
  if (data.source) host.insertAdjacentHTML("beforeend", `<p class="uc-src">${esc(data.source)}</p>`);
  host.insertAdjacentHTML(
    "beforeend",
    srTable(
      data.title || "Respondents by group",
      ["Group", "People", "Share"],
      segments.map((s) => [s.label, s.count, `${round(100 * s.count / total, 1)}%`])
    )
  );
}
